import { LuRefreshCcw } from 'react-icons/lu';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { generateContactSummary } from '../services/contacts';

const RelationshipSummaryCard = ({ contact, contactLoading, contactFetching, className = '' }) => {
  const { id } = useParams();
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();

  const summaryMutation = useMutation({
    mutationFn: (refresh = false) => generateContactSummary(accessToken, id, refresh),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contact', id] });
    },
  });

  const summaryText = contact?.summary?.summary;
  const summaryLoading = (contactLoading || contactFetching || summaryMutation.isPending) && !summaryText;

  return (
    <div className={`rounded-2xl border border-white/10 bg-white/5 p-4 text-sm text-slate-200 ${className}`}>
      <div className="mb-2 flex items-center justify-between">
        <p className="text-slate-400 font-semibold">Summary</p>
        <button
          type="button"
          onClick={() => summaryMutation.mutate(true)}
          disabled={summaryMutation.isPending || summaryLoading}
          aria-label="Refresh summary"
          title="Refresh Summary"
          className={`inline-flex items-center justify-center rounded-full border border-white/10 bg-white/5 p-2 text-slate-100 hover:bg-white/10 ${
            summaryMutation.isPending || summaryLoading ? 'opacity-60' : ''
          }`}
        >
          <LuRefreshCcw
            className={`h-4 w-4 ${summaryMutation.isPending || summaryLoading ? 'animate-spin text-slate-300' : 'text-slate-100'}`}
          />
        </button>
      </div>
      <div className="min-h-[48px]">
        {summaryLoading || summaryMutation.isPending ? (
          <div className="inline-flex items-center gap-2 text-slate-400">
            <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-slate-500 border-t-transparent" />
            <span>Loading summary…</span>
          </div>
        ) : summaryText ? (
          <p className="leading-relaxed text-slate-100">{summaryText}</p>
        ) : (
          <div className="flex flex-col items-center gap-3 text-center">
            <p className="text-slate-500">No summary available.</p>
            <button
              type="button"
              onClick={() => summaryMutation.mutate()}
              className="rounded-lg bg-sky-500/80 px-3 py-1 text-xs font-semibold text-slate-900 hover:bg-sky-400"
            >
              Generate summary
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RelationshipSummaryCard;
